class LocalServicePrinterApis {
  constructor(fetchClient) {
    this._fetchClient = fetchClient;
  }

  printLabels(body) {
    return this._fetchClient.post({
      path: "/printers/print",
      body
    });
  }

  getPrinters() {
    return this._fetchClient.get("/printers");
  }

  printTestLabel(printerName, printerType) {
    return this._fetchClient.post({
      path: "/printers/test",
      body: {
        printerName,
        printerType
      }
    });
  }

  configureUsbPrinter() {
    return this._fetchClient.get({
      path: "/printers/setup-drivers"
    });
  }

}

export default LocalServicePrinterApis;